import { RegistryIdentityNameKind } from '@navio/nsdk';
import { useRegistryIdentityNameOptions } from './useRegistryIdentityNameFilter';

/** Title, description and visible options of this filter, for the builder next to its options. */
export const CAR_MODEL_FILTER_TEXT = {
  title: 'Car models',
  description: 'Filter by specific car models',
  defaultVisibleOptions: 5
};

/** Registry car models as filter options (first 200), searchable. For `unit.multiSelect`. */
export const useCarModelNameOptions = () => useRegistryIdentityNameOptions(RegistryIdentityNameKind.MODEL);
